import React from 'react';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import { updateCurrentQueryDetiails } from '../../../actions/query';
import { connect } from 'react-redux';
import { Checkbox } from 'antd';

const IncludeNeighbourConnections = ({ values, setValues }: any) => {
  const onChange = (event: any) => {
    setValues({
      ...values,
      includeNeighbourConnections: event.target.checked,
    });
  };
  return (
    <div id="includeNeighbourConnections" className="w-full mt-5">
      <Checkbox
        checked={values.includeNeighbourConnections}
        onChange={onChange}
      >
        Include neighbour connections
      </Checkbox>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IncludeNeighbourConnections);
